export const FEED_DELETE_RESET = "FEED_DELETE_RESET";
export const FEED_DELETE_SET_ERROR = "FEED_DELETE_SET_ERROR";
export const FEED_DELETE_SET_DELETED = "FEED_DELETE_SET_DELETED";
export const FEED_DELETE_TOGGLE_LOADING = "FEED_DELETE_TOGGLE_LOADING";
